import Vue from 'vue';
import VueRouter from 'vue-router';
import BasicLayout from '../layout/BasicLayout.vue';
import login from '../views/user/login.vue';
import base from '../layout/BasicLayout.vue';
import tenant from '../views/user/tenant.vue';

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  routes: [

    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/base',
      name: 'base',
      component: base,
    },
    {
      path: '/tenants',
      name: 'tenants',
      component: tenant,
    },
    {
      path: '*',
      name: 'index',
      redirect: '/base',
    },
  ],
});

export default router;
